// extracted by mini-css-extract-plugin
export var addButton = "_f2-0";
export var border = "_f2-8";
export var check = "_f2-h";
export var danger = "_f2-6";
export var dropdownContainer = "_f2-1";
export var editModalBody = "_f2-j";
export var footerContainer = "_f2-i";
export var fullWidth = "_f2-a";
export var hide = "_f2-9";
export var icon = "_f2-3";
export var input = "_f2-7";
export var inputFlex = "_f2-b";
export var inputWrapper = "_f2-c";
export var manualFocus = "_f2-5";
export var optionButton = "_f2-4";
export var pillWrapper = "_f2-e";
export var pointer = "_f2-2";
export var showOverflow = "_f2-f";
export var tagsFlex = "_f2-d";
export var xButton = "_f2-g";